module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Shift-8d8da67db8c5d7db5ed5d2c679d8def5.svg";